import { render, staticRenderFns } from "./CheckUp.vue?vue&type=template&id=c57582ec&scoped=true"
import script from "./CheckUp.vue?vue&type=script&lang=js"
export * from "./CheckUp.vue?vue&type=script&lang=js"
import style0 from "./CheckUp.vue?vue&type=style&index=0&id=c57582ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57582ec",
  null
  
)

export default component.exports